import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isError: false,
};

const MainSlice = createSlice({
  name: "mainState",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.isError = action.payload;
    },
  },
});
export const { setLoading, setError } = MainSlice.actions;
export const selectMainState = (store) => store.mainState;

export default MainSlice.reducer;
